export const basicLayout = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/basicLayout.vue");
export const index = () =>
  import(/* webpackChunkName: "index" */ "@/views/Index.vue");
export const report = () =>
  import(/* webpackChunkName: "index" */ "@/views/Report.vue");
export const test1 = () =>
  import(/* webpackChunkName: "index" */ "@/views/test1.vue");
export const test2 = () =>
  import(/* webpackChunkName: "index" */ "@/views/test2.vue");
export const home = () =>
  import(/* webpackChunkName: "index" */ "@/views/home.vue");
export const ytcert = () =>
  import(/* webpackChunkName: "index" */ "@/views/ytCert.vue");
export const certMy = () =>
  import(/* webpackChunkName: "index" */ "@/views/cert/my.vue");
export const certHome = () =>
  import(/* webpackChunkName: "index" */ "@/views/cert/home.vue");
export const certList = () =>
  import(/* webpackChunkName: "index" */ "@/views/cert/certList.vue");
export const cert = () =>
  import(/* webpackChunkName: "index" */ "@/views/cert/cert.vue");
export const otherCert = () =>
  import(/* webpackChunkName: "index" */ "@/views/cert/otherCert.vue");